import * as actionTypes from "./actionTypes";
import { MenuAction, MenuState } from "./types/types";
import modules from "../mockData/modules.json";
import IDrawerMenus from "../interfaces/IDrawerMenus";

// Adicione este helper para mapear submodules recursivamente
const mapSubModules = (subs: any[]): any[] => {
  return subs.map((sub) => {
    const mappedSub: any = {
      id: sub.Key,
      label: sub.Label,
      resourceKey: sub.ResourceKey,
      icon: sub.Icon,
      route: sub.Route || "",
    };

    if (sub.SubModules) {
      mappedSub.SubModules = mapSubModules(sub.SubModules);
    }

    return mappedSub;
  });
};

// Todos os menus do modules.json são exibidos, exceto os ResourceKeys abaixo.
// "signout" fica de fora porque o logout real (que limpa a sessão e avisa o
// backend) já está no menu do usuário na TopBar; o item do menu lateral apenas
// navegaria para /login sem encerrar a sessão.
// Obs.: quem decide o recorte por usuário é `utilities/localizaMenu.ts`, em
// tempo de render — este estado inicial é montado no import, antes do login.
const HIDDEN_MENU_RESOURCE_KEYS = ["signout"];

const initialState: MenuState = {
  menus: modules
    .filter((module) => !HIDDEN_MENU_RESOURCE_KEYS.includes(module.ResourceKey))
    .map((module) => {
    const subModules = module.SubModules
      ? mapSubModules(module.SubModules)
      : [];
    // let subModules = module.SubModules?.map((sub) => {
    //   return {
    //     id: sub.Key,
    //     label: sub.Label,
    //     resourceKey: sub.ResourceKey,
    //     icon: sub.Icon,
    //     route: "Route" in sub ? sub.Route : "",
    //   };
    // });

    let response: IDrawerMenus = {
      id: module.Id,
      label: module.Name,
      resourcekey: module.ResourceKey,
      icon: module.Icons,
      SubModules: subModules,
      route: module.Route,
      isOpen: false,
    };

    return response;
  }),
  drawerOpened: true,
  selectedMenuId: "", // ou undefined, mas inicialize
};

const reducer = (
  state: MenuState = initialState,
  action: MenuAction,
): MenuState => {
  switch (action.type) {
    case actionTypes.ADD_MENU:
      return {
        ...state,
        menus: action.value,
      };
    case actionTypes.CHANGE_DRAWER:
      return {
        ...state,
        drawerOpened: !state.drawerOpened,
      };
    case actionTypes.SET_SELECTED_MENU_ID:
      return {
        ...state,
        selectedMenuId: action.value,
      };
  }
  return state;
};

export default reducer;
